export default __webpack_public_path__ + "static/media/gh.c4e2a8a1.jpg";